export default {
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        getCharterSchools(context) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/charters')
                    .then(resolve)
                    .catch(reject);
            });
        },
        addCharterSchool(context, {id, name}) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post('/dashboard/charters', {id: id, name: name})
                    .then(resolve)
                    .catch(reject);
            })
        },
        removeCharterSchool(context, id) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post('/dashboard/charters/delete', {id: id})
                    .then(resolve)
                    .catch(reject);
            })
        },
        searchSchools(context, {search, state}) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/schools/search', {params: {'search_string': search, 'state': state}})
                    .then(resolve)
                    .catch(reject);
            });

        },
        listDistrictsByState(context, searchState) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/schools/district/state', {params: {'search_state': searchState}})
                    .then(resolve)
                    .catch(reject);
            })
        },
        listSchoolsByDistrit(context, districtId) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/schools/district', {params: {'district_id': districtId}})
                    .then(resolve)
                    .catch(reject);
            })
        },
        listByZipcode(context, zipcode) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/schools/byZip', {params: {'zip': zipcode}})
                    .then(resolve)
                    .catch(reject);
            })
        }
    }
}
